const servicesControl = document.querySelector('.ume-lab-services-control');
const customEvent = new Event('customUmeEvent', {bubbles: true});
const select =  document.querySelector('.ume-lab-services-search-list');

const showKnowledge = (service = '', letter = '', search = '') => {
    if (service !== '') {
        showKnowledgePost(service, '', '');
        return;
    }
    handleControl(servicesControl, 'disable');
    const data = {
        action: 'get_services',
        ume_lab_nonce: ume_lab_env.ume_lab_nonce,
        letter: letter,
        search: search,
        service: service,
        the_url: window.location.href.split(/[?#]/)[0],


    };
    jQuery('.ume-lab-services-holder').html('');
    jQuery.post(ume_lab_env.ume_lab_ajax_url, data, function (response) {

        if (response) {


            jQuery('.ume-lab-services-holder').append(response);
            handleControl(servicesControl, 'enable');
        }

    })
    const holder = document.querySelector('.ume-lab-services-holder');
    if(holder !== null){
        holder.setAttribute('data-active-search', search);
        holder.setAttribute('data-active-service', service);
        holder.setAttribute('data-active-letter', letter);
    }



}
const showKnowledgePost = (post, letter = '', search = '') => {
    handleControl(servicesControl, 'disable');
    const data = {
        action: 'get_services_post',
        ume_lab_nonce: ume_lab_env.ume_lab_nonce,
        post: post,
        letter: letter,


    };
    jQuery('.ume-lab-services-holder').html('');
    jQuery.post(ume_lab_env.ume_lab_ajax_url, data, function (response) {

        if (response) {


            jQuery('.ume-lab-services-holder').append(response);
            handleControl(servicesControl, 'enable');
            servicesControl.dispatchEvent(customEvent);

        }

    })



}
const handleControl = (cb, status) =>{
    select.classList.add('d-none');

    if(cb !== null){
        let searchInput = cb.querySelector('.ume-lab-services-search-input');
        let searchButton = cb.querySelector('.ume-lab-services-search-trigger');
        let umeSelectHolder = cb.querySelector('.ume-lab-services-select-holder');
        let spinner = cb.querySelector('.ume-lab-services-spinner');
        if(status === 'disable'){
            if(umeSelectHolder !== null){
                umeSelectHolder.classList.add('ume-lab-services-select-holder__disabled');
            }

            if(searchInput !== null){
                searchInput.disabled = true;
                searchInput.setAttribute('aria-disabled', 'true');
                searchButton.classList.add('disabled');
                searchButton.setAttribute('aria-disabled', 'true');
            }
            if(spinner !== null){
                spinner.classList.remove('d-none');
            }
            return 'disabled';
        }
        if(status === 'enable'){
            if(umeSelectHolder !== null){
                umeSelectHolder.classList.remove('ume-lab-services-select-holder__disabled');
            }

            if(searchInput !== null){
                searchInput.disabled = false;
                searchInput.setAttribute('aria-disabled', 'false');
                searchButton.classList.remove('disabled');
                searchButton.setAttribute('aria-disabled', 'false');
            }
            if(spinner !== null){
                spinner.classList.add('d-none');
            }
            return 'enabled';
        }
        return 'failed';
    }
    return null;
}
const runInitialLoad = () => {
    if (document.querySelector('.ume-lab-services-holder')) {
        let holder = document.querySelector('.ume-lab-services-holder');
        let letter = holder.getAttribute('data-active-letter');
        let search = holder.getAttribute('data-active-search');
        let service = holder.getAttribute('data-active-service');


        if(service !== ''){
            showKnowledge(service, '', '');
            return;
        }
        if(search !== ''){
            showKnowledge('', '', search);
            return
        }
        showKnowledge('', letter, '');

    }
}
jQuery(document).ready(function () {
    runInitialLoad();


    jQuery(document).on('click', '.ume-lab-services-letter-select-button', (event) => {

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        let theLetter = event.target.innerHTML;
        let parent = event.target.closest('.ume-lab-services-holder');
        parent.setAttribute('data-active-letter', theLetter);

        showKnowledge('', theLetter, '');
        window.history.pushState({}, document.title + theLetter, window.location.href.split(/[?#]/)[0] + '?umeLabInitial='+encodeURIComponent(theLetter));


    })
    jQuery(document).on('click', '.ume-lab-services-load-post', (event) => {

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        let post = event.target.innerHTML;
        let parent = event.target.closest('.ume-lab-services-holder');
        let letter = parent.getAttribute('data-active-letter');
        parent.setAttribute('data-active-letter', '');

        showKnowledgePost(post, letter);
        window.history.pushState({}, document.title + post, window.location.href.split(/[?#]/)[0] + '?umeLabService='+encodeURIComponent(post));


    })
    jQuery(document).on('click', '.ume-lab-services-letter-reset-button', (event) => {

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }


        showKnowledge();
        window.history.pushState({}, document.title, window.location.href.split(/[?#]/)[0]);


    })
    jQuery(document).on('click', '.ume-lab-services-letter-reset-search', (event) => {

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }
        let searchInput = document.querySelector('.ume-lab-services-search-input');
        if(searchInput !== null){
            searchInput.value = '';
        }

        showKnowledge();
        window.history.pushState({}, document.title, window.location.href.split(/[?#]/)[0]);


    })

    document.addEventListener('click', ev => {
        if(ev.target.closest('.ume-lab-services-search-trigger')) {
            ev.preventDefault();
            const button = ev.target.closest('.ume-lab-services-search-trigger');
            const inputSearch = button.previousElementSibling;
            select.classList.add('d-none');
            if(inputSearch.value !== ''){
                showKnowledge('', '', inputSearch.value);
                window.history.pushState({}, document.title + inputSearch.value, window.location.href.split(/[?#]/)[0] + '?umeLabSearch='+encodeURIComponent(inputSearch.value));
            }
        }
        if(ev.target.closest('.ume-lab-services-back-to-filter')){
            ev.preventDefault();
            select.classList.add('d-none');
            let setLetter = ev.target.getAttribute('data-selected-letter');


            showKnowledge('', setLetter, '');
            if(setLetter === ''){
                window.history.pushState({}, document.title, window.location.href.split(/[?#]/)[0]);

            }
            if(setLetter !== ''){
                window.history.pushState({}, document.title + setLetter, window.location.href.split(/[?#]/)[0] + '?umeLabInitial='+encodeURIComponent(setLetter));

            }
        }
        return;



    });
    document.addEventListener('keypress', ev =>{
       let inputField = document.querySelector('.ume-lab-services-search-input');
        if(ev.key === 'Enter' && inputField == document.activeElement){
            select.classList.add('d-none');
            if(inputField.value !== ''){
                showKnowledge('', '', inputField.value);
                window.history.pushState({}, document.title + inputField.value, window.location.href.split(/[?#]/)[0] + '?umeLabSearch='+encodeURIComponent(inputField.value));
            }
        }
    })
});
window.addEventListener('popstate', ev =>{
    if(document.querySelector('.ume-lab-services-control')){
        window.location.reload();
    }
}, false)
export default showKnowledge;